import axios from 'axios';

import getHeaderToken from 'functions/getHeaderToken';

import{ Logger } from 'aws-amplify';
const logger = new Logger('CorporationCollaboration-log');

const getCorporationCollaboration = async (url, officeNumber, isCorporation = true) => {

    // 法人の場合はcorporation_office_number、施設の場合はfacility_office_numberで検索
    const params = isCorporation
        ? { corporation_office_number: officeNumber }
        : { facility_office_number: officeNumber };

    const header = await getHeaderToken();
    const config = Object.assign(header, { params });

    try {
        const res = await axios.get(url, config);
        if (res.status === 200) {
            // APIは施設番号の文字列配列を返すので、オブジェクト配列に変換
            const facilities = res.data.collaborated_facilities || [];
            const collaborations = facilities.map(officeNumber => ({
                facility_office_number: officeNumber
            }));

            if (isCorporation) {
                // 法人の場合: オブジェクト配列のみ返す（従来互換）
                return collaborations;
            } else {
                // 施設の場合: 追加情報も含めて返す
                return {
                    collaborated_facilities: collaborations,
                    corporation_office_number: res.data.corporation_office_number || null,
                    is_read_only: res.data.is_read_only !== false
                };
            }
        } else {
            logger.error(res);
            return isCorporation ? [] : { collaborated_facilities: [], is_read_only: true };
        }
    } catch (e) {
        logger.error(e);
        return isCorporation ? [] : { collaborated_facilities: [], is_read_only: true };
    }

};

export default getCorporationCollaboration;
